<template>
  <span v-if="eventType.match(/drinnen|indoor/i)" class="pill pill--info pill--inverted">
    <i class="icon fa fa-home"></i>
    {{ eventType }}
  </span>
  <span v-else-if="eventType.match(/draußen|outdoor|sport im park/i)" class="pill pill--success pill--inverted">
    <i class="icon fa fa-tree"></i>
    {{ eventType }}
  </span>
  <span v-else class="pill pill--info pill--inverted">
    {{ eventType }}
  </span>
</template>

<script>
export default {
  props: ['eventType'],
}
</script>
